import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
import React from 'react';
import { Button } from 'semantic-ui-react';
import InternalLink from '../../../../atoms/InternalLink/InternalLink';
import OutboundLink from '../../../../atoms/OutboundLink/OutboundLink';
import { classNames } from '../../../../utils/classname';
import { addSlashPrefix, isUrl } from '../../../../utils/urls';
import useSemanticUiProps from '../../../foundation/hooks/use-semantic-ui-props/use-semantic-ui-props';
import { INTERACTION_DISPLAY_TYPE_BUTTON, INTERACTION_STYLE_TO_CLASSNAME } from '../../constants';
function getStyleClassName(interaction) {
  var style = interaction.style;
  return INTERACTION_STYLE_TO_CLASSNAME[style] || '';
}
export function getLinkComponent(interaction) {
  var url = interaction.url;
  if (isUrl(url)) {
    return OutboundLink;
  }
  return InternalLink;
}
export function getDisplayComponent(interaction) {
  var displayType = interaction.displayType;
  var LinkComponent = getLinkComponent(interaction);
  if (displayType === INTERACTION_DISPLAY_TYPE_BUTTON) {
    return /*#__PURE__*/React.createElement(Button, {
      as: LinkComponent
    });
  }
  return /*#__PURE__*/React.createElement(LinkComponent, null);
}
export function getLinkComponentProps(interaction) {
  var url = interaction.url;
  if (isUrl(url)) {
    return {
      to: url
    };
  }
  return {
    to: addSlashPrefix(url),
    activeClassName: '',
    activeStyle: {}
  };
}
export function getDisplayComponentProps(_ref) {
  var _classNames;
  var interaction = _ref.interaction,
    className = _ref.className,
    displayComponentPropsMap = _ref.displayComponentPropsMap,
    event = _ref.event;
  var displayType = interaction.displayType,
    label = interaction.label;
  var styleClassName = getStyleClassName(interaction);
  var finalClassName = classNames((_classNames = {
    'interaction-cta-link': true
  }, _defineProperty(_classNames, className, className), _defineProperty(_classNames, styleClassName, styleClassName), _classNames));
  var baseProps = _objectSpread(_objectSpread({
    className: finalClassName
  }, getLinkComponentProps(interaction)), {}, {
    event: event ? _objectSpread(_objectSpread({}, event || {}), {}, {
      label: label
    }) : null
  });
  var _useSemanticUiProps = useSemanticUiProps(),
    getButtonProps = _useSemanticUiProps.getButtonProps;
  if (displayType === INTERACTION_DISPLAY_TYPE_BUTTON) {
    return _objectSpread(_objectSpread({}, getButtonProps(displayComponentPropsMap[displayType])), baseProps);
  }
  return _objectSpread(_objectSpread({}, displayComponentPropsMap[displayType]), baseProps);
}